
import { createSelector } from 'reselect';

const sivErrorSelector = state => state.sivError || false;

export const getSivError = createSelector(
    sivErrorSelector,
    sivError => sivError
);